import {modalWindowSvg as Icon__small__modalWindowSvg} from '../Icon__small/Icon__small--modalWindow.js';

export var modalWindow = {
  name: 'modalWindow',
  category: 'icon',
  colorable: true,
  svg: Icon__small__modalWindowSvg,
};
